// External deps
import { useEffect } from 'react';
import { Loader } from 'ypf-pas-general-ui-components';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

// Internal deps
import { useAppContext } from '../../context/AppProvider';
import NavBar from '../../components/NavBar/NavBar';
import Login from '../../page/Login/Login';
import ServiceRequest from '../../page/ServiceRequest/ServiceRequest';
import FilterProvider from '../../context/FilterContext';
// from '../../page/ServiceRequest/CreateServiceRequest/CreateServiceRequest';
import DetailServiceRequest from '../../page/ServiceRequest/DetailServiceRequest/DetailServiceRequest';
import SimplifiedCharging from '../../page/SimplifiedCharging/SimplifiedCharging';
import MonthlyDetailServiceRequest from '../../page/MonthlyServiceRequest/MonthlyDetailServiceRequest/MonthlyDetailServiceRequest';
import FilesProvider from '../../context/FilesProvider';
import { FilesSdsPtProvider } from '../../context/FilesSdsPtContext';
import { WorkReportProvider } from '../../context/WorkReportProvider';
import DetailsEventsModalProvider from '../../context/DetailsEventsModalContext';
import PermissionsRoute from '../../components/PermissionRoute/PermissionRoute';
import {
  CrearSDS,
  VisualizarPT,
  VisualizarSDS,
  VerDetalleSDSInterno,
  BandejaInspeccion
} from '../../security/constantsPermissions';
import WorkReportModalsProvider from '../../context/WorkReportModalsContext';
import CalendarProvider from '../../context/CalendarProvider';
import AutomaticServiceRequest from '../../page/AutomaticServiceRequest/AutomaticServiceRequest';
import CreateMultipleServiceRequest from '../../page/ServiceRequest/CreateMultipleServiceRequest/CreateMultipleServiceRequest';
import ApproverViewLayout from '../../page/ApproverWorkReport/ApproverViewLayout';
import GenerateTemplate from '../../page/ManageTemplate/GenerateTemplate/GenerateTemplate';
import EditTemplate from '../../page/ManageTemplate/EditTemplate/EditTemplate';
import GenerateRequestTemplate from '../../components/Templates/RequestTemplate/GenerateRequestTemplate/GenerateRequestTemplate';
import ManageTemplatePage from '../../page/ManageTemplate/ManageTemplatePage';
import ApproverWeeklyWorkReport from '../../page/ApproverWeeklyWorkReport/ApproverWeeklyWorkReport';
import InspectorWeeklyWorkReport from '../../page/InspectorWeeklyWorkReport/InspectorWeeklyWorkReport';
import NotificationReport from '../../page/NotificationReport/NotificationReport';
import TermsOfServicePage from '../../page/TermsOfService/TermsOfService';
import { homeWebYClick } from '../../resources/environmentConstants';
import useLocalStorage from '../../hooks/useLocalStorage';
import ProvisionReport from '../../components/ProvisionReport/ProvisionReport';
import DetailsFiltersProvider from '../../context/FilterDetailSDSContext';
import { DetailServiceRequestProvider } from '../../context/DetailServiceRequestProvider';

const AppPrivate = () => {
  const { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } = useLocalStorage();
  const iframe = document.querySelector('iframe');

  if (iframe) iframe.remove();

  const { ready, auth } = useAppContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => removeLocalStorageItem('homeURL'), []);

  const getHomeRedirectURL = () => {
    if (!getLocalStorageItem('homeURL')) {
      const isnr = getLocalStorageItem('nr_isnr');

      let NRParams = '';

      if (isnr === '1') {
        const queryNRContractNumber = encodeURIComponent(getLocalStorageItem('nr_cn'));
        const queryNRWell = encodeURIComponent(getLocalStorageItem('nr_wl'));
        const queryNRDateFrom = encodeURIComponent(getLocalStorageItem('nr_df'));
        const queryNRDateTo = encodeURIComponent(getLocalStorageItem('nr_dt'));

        NRParams = `?nr_isnr=1&nr_cn=${queryNRContractNumber}&nr_wl=${queryNRWell}&nr_df=${queryNRDateFrom}&nr_dt=${queryNRDateTo}`;
      } else {
        NRParams = `?nr_isnr=0`;
      }

      removeLocalStorageItem('nr_isnr');
      removeLocalStorageItem('nr_cn');
      removeLocalStorageItem('nr_wl');
      removeLocalStorageItem('nr_df');
      removeLocalStorageItem('nr_dt');
      const homeUrl = `${homeWebYClick}/#/login${NRParams}`;

      setLocalStorageItem('homeURL', homeUrl);

      return homeUrl;
    }

    return getLocalStorageItem('homeURL');
  };

  if (!ready) {
    return <Loader show text="CARGANDO ..." />;
  }

  if (!auth) {
    if (window.location.hostname === 'localhost') {
      return <Login />;
    }
    const navigator = window.location;

    navigator.replace(getHomeRedirectURL());

    return null;
  }

  return (
    <Router>
      <DetailsEventsModalProvider>
        <FilesProvider>
          <CalendarProvider>
            <WorkReportModalsProvider>
              {auth && <NavBar />}
              <Switch>
                <PermissionsRoute path="/createMultiple" permission={[CrearSDS]}>
                  <CreateMultipleServiceRequest />
                </PermissionsRoute>
                <PermissionsRoute path="/create-asds" permission={[]}>
                  <AutomaticServiceRequest />
                </PermissionsRoute>
                <PermissionsRoute exact path="/manage-temp/:typeOfTemplate" permission={[]}>
                  <ManageTemplatePage />
                </PermissionsRoute>
                <PermissionsRoute exact path="/generate-template/request" permission={[CrearSDS]}>
                  <GenerateRequestTemplate />
                </PermissionsRoute>
                <PermissionsRoute exact path="/edit-template/request/:id" permission={[CrearSDS]}>
                  <GenerateRequestTemplate />
                </PermissionsRoute>
                <PermissionsRoute exact path="/generate-template" permission={[]}>
                  <DetailServiceRequestProvider>
                    <GenerateTemplate />
                  </DetailServiceRequestProvider>
                </PermissionsRoute>
                <PermissionsRoute exact path="/edit-template" permission={[]}>
                  <DetailServiceRequestProvider>
                    <EditTemplate />
                  </DetailServiceRequestProvider>
                </PermissionsRoute>
                <PermissionsRoute exact path="/edit-template/:idTemplate" permission={[]}>
                  <DetailServiceRequestProvider>
                    <EditTemplate />
                  </DetailServiceRequestProvider>
                </PermissionsRoute>
                <PermissionsRoute path="/edit/:id" permission={[CrearSDS]}>
                  <CreateMultipleServiceRequest />
                </PermissionsRoute>
                <PermissionsRoute
                  path="/detail/:id"
                  permission={[VisualizarSDS, VerDetalleSDSInterno]}
                >
                  <DetailServiceRequestProvider montly={false}>
                    <DetailsFiltersProvider>
                      <WorkReportProvider>
                        <FilesSdsPtProvider>
                          <DetailServiceRequest />
                        </FilesSdsPtProvider>
                      </WorkReportProvider>
                    </DetailsFiltersProvider>
                  </DetailServiceRequestProvider>
                </PermissionsRoute>
                <PermissionsRoute
                  path="/detailmonthly/:id/simplifiedcharging/:month/:year/:isOrderByUbication/:number"
                  permission={[VisualizarSDS]}
                >
                  <DetailsFiltersProvider>
                    <SimplifiedCharging />
                  </DetailsFiltersProvider>
                </PermissionsRoute>
                <PermissionsRoute
                  path="/detailmonthly/:id"
                  permission={[VisualizarSDS, VerDetalleSDSInterno]}
                >
                  <DetailServiceRequestProvider montly>
                    <DetailsFiltersProvider>
                      <FilesSdsPtProvider>
                        <MonthlyDetailServiceRequest />
                      </FilesSdsPtProvider>
                    </DetailsFiltersProvider>
                  </DetailServiceRequestProvider>
                </PermissionsRoute>
                <PermissionsRoute
                  exact
                  path="/approver/weekly-work-report/:date"
                  permission={[VisualizarPT]}
                >
                  <FilesSdsPtProvider>
                    <ApproverWeeklyWorkReport />
                  </FilesSdsPtProvider>
                </PermissionsRoute>
                <PermissionsRoute
                  exact
                  path="/inspector/weekly-work-report"
                  permission={[BandejaInspeccion]}
                >
                  <FilesSdsPtProvider>
                    <InspectorWeeklyWorkReport />
                  </FilesSdsPtProvider>
                </PermissionsRoute>
                <PermissionsRoute exact path="/inspector/service" permission={[BandejaInspeccion]}>
                  <FilterProvider>
                    <ServiceRequest />
                  </FilterProvider>
                </PermissionsRoute>
                <PermissionsRoute path="/approver" permission={[VisualizarPT]}>
                  <FilterProvider>
                    <FilesSdsPtProvider>
                      <ApproverViewLayout />
                    </FilesSdsPtProvider>
                  </FilterProvider>
                </PermissionsRoute>
                <PermissionsRoute exact path="/notification-report" permission={[]}>
                  <NotificationReport />
                </PermissionsRoute>
                <PermissionsRoute exact path="/reporte-provision" permission={[]}>
                  <ProvisionReport />
                </PermissionsRoute>
                <PermissionsRoute exact path="/termsofservice" permission={[]}>
                  <TermsOfServicePage />
                </PermissionsRoute>
                <PermissionsRoute path="/">
                  <FilterProvider>
                    <ServiceRequest />
                  </FilterProvider>
                </PermissionsRoute>
              </Switch>
            </WorkReportModalsProvider>
          </CalendarProvider>
        </FilesProvider>
      </DetailsEventsModalProvider>
    </Router>
  );
};

export default AppPrivate;
